import {createRouter, createWebHashHistory, RouteRecordRaw} from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'mode-selection',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/patients',
    name: 'patient-management',
    component: () => import('../views/PatientManagement.vue')
  },
  {
    path: '/hand-selection',
    name: 'hand-selection',
    component: () => import('../views/HandSelection.vue')
  },
  {
    path: '/joint-selection',
    name: 'joint-selection',
    component: () => import('../views/JointSelection.vue')
  },
  {
    path: '/parameter-input',
    name: 'parameter-input',
    component: () => import('../views/ParameterInput.vue')
  },
  {
    path: '/passive',
    name: 'passive-training',
    component: () => import('../views/PassiveTraining.vue')
  },
  {
    path: '/active',
    name: 'active-training',
    component: () => import('../views/ActiveTraining.vue')
  },
  {
    path: '/demo',
    name: 'demonstration-mode',
    component: () => import('../views/DemonstrationMode.vue')
  },
  {
    path: '/start-training',
    name: 'start-training',
    component: () => import('../views/StartTraining.vue')
  },
  {
    path: '/training-setup',
    name: 'training-setup',
    component: () => import('../views/TrainingSetup.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/game',
    name: 'game',
    component: () => import('../views/GameView_1.vue')
  },
  {
    path: '/game2',
    name: 'game2',
    component: () => import('../views/GameView_2.vue')
  },
  {
    path: '/game3',
    name: 'game3',
    component: () => import('../views/GameView_3.vue')
  },
  {
    path: '/game4',
    name: 'game4',
    component: () => import('../views/GameView_4.vue')
  },
  {
    path: '/game4-shoulder-flexion',
    name: 'game4-shoulder-flexion',
    component: () => import('../views/GameView_4_shoulderFlexion.vue')
  },
  {
    path: '/game-garbage',
    name: 'game-garbage',
    component: () => import('../views/GameView_5.vue')
  },
  {
    path: '/game6',
    name: 'game6',
    component: () => import('../views/GameView_6.vue')
  },
  {
    path: '/game7',
    name: 'game7',
    component: () => import('../views/GameView_7.vue')
  },
  {
    path: '/game-elbow',
    name: 'game-elbow',
    component: () => import('../views/GameView_1_elbow.vue')
  },
  {
    path: '/game2-elbow',
    name: 'game2-elbow',
    component: () => import('../views/GameView_2_elbow.vue')
  },
  {
    path: '/game3-elbow',
    name: 'game3-elbow',
    component: () => import('../views/GameView_3_elbow.vue')
  },
  {
    path: '/game4-elbow',
    name: 'game4-elbow',
    component: () => import('../views/GameView_4_elbow.vue')
  }
]

const router = createRouter({
  // mode: 'hash', // 去掉url中的#
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
